<template>
  <div>
    <div id="content">
		<div class="row">
			<div class="col-md-10"></div>
			<div class="col-md-2"><b-button v-b-toggle.sidebar size="sm" pull-right>Show My Fact Card</b-button><br/><br/></div>
		</div>
		<div class="row">
			<div class="col-md-12">
				<b-form-input placeholder="search" class="mb-2" v-model="search"></b-form-input>
				<b-table :items="criteria" :filter="search" :fields="['fact', 'description']" striped hover small bordered></b-table>
			</div>
		</div>
	</div>
	<b-sidebar id="sidebar" class="sidebar" title="Fact Card" bg-variant="dark" right shadow>
		<div class="px-3 py-2">
			<div v-for="(value, name) in facts" :key="name">
				{{ name }}: {{ value }}
			</div>
		</div>
	</b-sidebar>
</div>
</template>
<script>
export default {
	name: "PSMs",
	data() {
		return {
			criteria: null,
			facts: null,
			search: "",
		};
	},
	methods: {
		getCriteria: function () {
		this.$http.get(this.$config.ApiUri + "/Criteria").then((result) => {
			this.criteria = result.data;
			this.criteria.sort();
			this.$http.get(this.$config.ApiUri + "/Customers/00000000-0000-0000-0000-000000000000").then((result) => {
				this.facts = result.data.facts;
			});
		});
		},
		onLoad() {
		this.getCriteria();
		},
	},
	mounted: function () {
		this.onLoad();
	},
};
</script>
	
<style>
</style>